import React, { Component } from 'react'
import { Button } from '@progress/kendo-react-buttons'
import { DatePicker } from '@progress/kendo-react-dateinputs';
import { Input } from '@progress/kendo-react-inputs';

 class Destruction extends Component {
     constructor(props){
         super(props);
         this.state={
            Data: {},
         }
     }
     handleChange=(e)=>{
         let {value,name}= e.target;
         let {Data}=this.state;
         Data[name]=value;
         this.setState({
             Data,
         })
     }

     handleSubmit=()=>{
         
     }

    render() {
        return (
            <div className="modal-content">
                <div className="modal-header">
                    <span className="modal-title bold" style={{fontSize:"large"}}>
                        <b>Destruição</b>
                    </span>
                    <div className="buttons">
                        <Button primary={true} className="remove btn-ivdp-primary cursor-pointer mr-2" onClick={() => this.handleSubmit()}>Confirmar</Button>
                        <Button className="mr-2 k-primary btn-ivdp-secondary btn-theme remove ml-2 text-danger" data-dismiss="modal">Fechar</Button>
                    </div>
                </div>
                <div className="modal-body">
                    <div className="mx-auto mt-3 ml-3" style={{width: "90%"}}>
                        <div className="label-group">
                            <label className="w-100">
                                <strong>Data de realização</strong>
                                <DatePicker
                                    className="form-control deadlineclender w-100 input-1"
                                    name="dataBoletim"
                                    placeholder="Data última vistoria"
                                    label="Data última vistoria"
                                    format="dd/MMM/yyyy"
                                    readOnly={true}
                                    max={new Date()}
                                    onChange={(e)=>this.handleChange(e)}
                                />
                            </label>
                        </div>
                        
                        <div className="label-group my-4 input-box">
                            <label className="w-100">
                                <strong>Local</strong>
                                <Input
                                    style={{ width: "100%" }}
                                    className="input-1"
                                    name="geocodigo"
                                    onChange={(e)=>this.handleChange(e)}
                                />
                            </label>
                        </div>
                        <div className="label-group my-4 input-box">
                            <label className="w-100">
                                <strong>Responsável (Entidade recetora)</strong>
                                <Input
                                    style={{ width: "100%" }}
                                    className="input-1"
                                    name="responsible"
                                    onChange={(e)=>this.handleChange(e)}
                                />
                            </label>
                        </div>
                        <div className="input-box active-grey">
                            <label className="w-100">
                                <strong>Observações</strong>
                                <textarea
                                    className="form-control w-100 heigh-auto" 
                                    rows="3"
                                    name="Observe"
                                    onChange={(e)=>this.handleChange(e)}
                                >
                                </textarea>
                            </label>
                        </div>
                        <div className="read-only-group my-4">
                            <p className="my-1"><strong>Data da ação</strong></p>
                            <p>Lorem ipsum</p>
                        </div>
                        <div className="read-only-group my-4">
                            <p className="my-1"><strong>Utilizador da ação</strong></p>
                            <p>Lorem ipsum</p>
                        </div>
                    </div>
                </div>
                
            </div>
        )
    }
}
export default Destruction